


















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { classroomListApi, classroomDelApi } from "@/api/classRoom";
import addDialog from "@/components/addClassRoomDialog.vue";
import eventBus from "@/utils/bus";
import { dateFormat } from "@/utils/timeFormat";
@Component({
  components: {
    addDialog,
  },
})
export default class extends Vue {
  fromData = {
    class_name: "",
    sort_type: "desc",
    sort_field: "create_time",
  };
  tableData = [];
  total = 0;
  page = 1;
  pageSize = 10;
  pageSizeArray = [5, 10, 30, 50, 100];
  addClassRoomDrawerVisible: boolean = false;
  titleName = 0; // 决定显示名称
  editInfo = {};
  created() {
    eventBus.$on("initClassRoomManagement", () => {
      this.getList({
        page: 1,
        page_size: 10,
      });
    });
    this.getList({
      page: 1,
      page_size: 10,
    });
  }
  beforeDestroy() {
    eventBus.$off("initClassRoomManagement");
  }
  goClassRoomTimeTable(it: any) {
    this.$router.push({
      name: "storeSchedule",
      query: {
        fromClassroomId: it.classroom_id,
      },
    });
  }
  getList(data: { page: number; page_size: number }) {
    const option: any = {
      page: data.page,
      page_size: data.page_size,
    };
    if (this.fromData.class_name) {
      option.name = this.fromData.class_name;
    }
    if (this.fromData.sort_type) {
      option.sort_type = this.fromData.sort_type;
    }
    if (this.fromData.sort_field) {
      option.sort_field = this.fromData.sort_field;
    }
    classroomListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    });
  }
  getTime(e: any) {
    // let weekZh = ["日", "一", "二", "三", "四", "五", "六"];
    // let v = "（周" + weekZh[e.getDay()] + "）";
    const format = dateFormat("YYYY-mm-dd HH:MM", e);
    return format.slice(0, 10) + " " + format.slice(11);
  }
  clickSort(e: { order: string; prop: string }) {
    this.fromData.sort_field = e.prop;
    if (e.order == "descending") {
      this.fromData.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.fromData.sort_type = "asc";
    } else {
      this.fromData.sort_type = "";
    }
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  handleSearch(e: any) {
    this.getList({
      page: 1,
      page_size: 10,
    });
  }
  handleSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  handleCurrentChange(e: number) {
    this.page = e;
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  delClassRoom(delInfo: any) {
    this.$confirm(
      "删除教室后，已分配教室的班级、课次则不再显示教室信息，确定要删除教室？",
      `删除教室 - ${delInfo.name}`,
      {
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonClass: "mwow-button-filled success",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled",
        iconClass: "mwow-icon-error",
      }
    )
      .then(() => {
        classroomDelApi({
          classroom_id: delInfo.classroom_id,
        }).then((res: any) => {
          if (res.error_code === 0) {
            this.$message({
              message: "教室已删除",
              type: "success",
            });
            eventBus.$emit("initClassRoomManagement");
          }
        });
      })
      .catch(() => {});
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  showAddDialog() {
    this.addClassRoomDrawerVisible = true;
    this.titleName = 1;
  }
  editClassRoom(edit: any) {
    this.editInfo = edit;
    this.addClassRoomDrawerVisible = true;
    this.titleName = 2;
  }
}
